import React, { useState } from "react";
import { Button, Input, Message } from "../../../BP2Components";
import { useDispatch } from "react-redux";
import { setWidgetInSheetParams } from "appRedux/actions/Actions";
import IntlMessages from "@util/IntlMessages";
import { useIntl } from "react-intl";

const NewsletterSettings = ({ value }) => {
   const dispatch = useDispatch();
   const intl = useIntl();
   const [settings, setSettings] = useState({
      ...value
   });

   const handleSubmit = (e) => {
      e.preventDefault();
      dispatch(setWidgetInSheetParams(settings));
      Message.success(intl.formatMessage({ id: "save.modal" }));
   };

   const handleChangeInput = (name) => (e) => {
      setSettings({ ...settings, [name]: +e.target.value });
   };

   return (
      <>
         <form onSubmit={handleSubmit}>
            <div className="widget-settings">
               <div className="widget-settings__inner">
                  <label key="newsletterId" className="widget-settings__inner__label">
                     <IntlMessages id="settings.newsletterId" />:
                     <Input
                        type="number"
                        name="newsletterId"
                        defaultValue={value.newsletterId}
                        onChange={handleChangeInput("newsletterId")}
                     />
                  </label>
               </div>
               <Button buttonType="primary" htmlType="submit">
                  <IntlMessages id="global.save" />
               </Button>
            </div>
         </form>
      </>
   );
};

export default NewsletterSettings;
